import React from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const Breadcrumb = ({ title, breadcrumbItem, url }) => {
  const history = useHistory();

  return (
    <div className="row">
      <div className="col">
        <div className="page-title-box">
          <div className="d-flex justify-content-start mb-1">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-2">
                <li className="breadcrumb-item">
                  <Link to={url}>{title}</Link>
                </li>
                {breadcrumbItem && (
                  <li className="breadcrumb-item active" aria-current="page">
                    {breadcrumbItem?.charAt(0)?.toUpperCase() +
                      breadcrumbItem?.slice(1)}
                  </li>
                )}
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
